export const common = {    
    init: ()=>{

    },
    trim: (value)=>{
        if(value !== undefined && typeof value == "string"){
            return value.trim()
        }else{
            return ""
        }
    }
}